export const API_ENDPOINTS = {
    cart: {
        get: '/cart.js',
        add: '/cart/add.js',
        update: '/cart/update.js',
        change: '/cart/change.js',
        clear: '/cart/clear.js',
    }
}
